import type { ContentMode } from "./types";

export function resolveContentMode(value: string | undefined, isDevelopment = false): ContentMode {
  if (value === "preview" || isDevelopment) {
    return "preview";
  }

  return "published";
}
